import sharedStyles from '@muiscss/sharedStyles.module.scss'
import clsx from 'clsx'
import { forwardRef } from 'react'
import styles from './styles.module.scss'
import { ICheckboxProps } from './types'

// TODO CHECKBOXES AND RADIOS SHARE ALL CODE EXCEPT THE LABEL SCSS

const Checkbox = forwardRef<HTMLInputElement, ICheckboxProps>(
  (
    {
      checked,
      defaultChecked,
      disabled = false,
      hasError,
      id,
      label,
      name,
      required,
      size = 'md',
      slots,
      style,
      variant = 'default',
      className,
      ...props
    },
    ref,
  ) => {
    /**
     * If the checked prop is passed, we want to use the controlled mode of the component.
     * If the checked prop is not passed, we want to use the uncontrolled mode of the component.
     */
    const controlModeProps = checked !== undefined ? { checked } : { defaultChecked }

    return (
      <span className={clsx(styles.option, className)} data-testid="mui-checkbox" style={style}>
        <div
          className={clsx(styles.inputHolder, styles[size], {
            [styles.border]: variant === 'bordered',
          })}
        >
          <input
            className={`mui-checkbox ${styles.checkbox}`}
            data-testid={`mui-checkbox-${id}`}
            disabled={disabled}
            id={id}
            name={name || `${id}-checkbox`}
            ref={ref}
            required={required}
            type="checkbox"
            {...controlModeProps}
            {...props}
          />
          <label
            className={clsx(styles.label, sharedStyles.label, styles[size], {
              [sharedStyles.disabled]: disabled,
              [styles.error]: hasError,
            })}
            data-style="checkbox-content"
            data-testid={`test-checkbox-label-${id}`}
            htmlFor={id}
          >
            {slots?.before && <span className={clsx(styles.slotsBefore)}>{slots.before}</span>}
            {label}
            {slots?.after && <span className={clsx(styles.slotsAfter)}>{slots.after}</span>}
          </label>
        </div>
      </span>
    )
  },
)

Checkbox.displayName = 'Checkbox'

export default Checkbox
